module.exports = __webpack_public_path__ + "static/media/series.8a811d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/series.svg
// module id = 97
// module chunks = 0